module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.show) ? _c('dof-overlay', {
    attrs: {
      "show": _vm.show,
      "hasAnimation": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "dofModalWrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.layoutClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-box weex-ct weex-div",
    style: (_vm._px2rem(_vm._modalStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return (function () {})($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content weex-ct weex-div",
    style: (_vm._px2rem(_vm.modalContentStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("title", [(_vm.title) ? _c('p', {
    staticClass: "content-title weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()], {}), _vm._v(" "), _vm._t("image", [(_vm.image) ? _c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: ("cover"),
      expression: "\"cover\""
    }],
    staticClass: "content-image weex-el weex-image",
    style: (_vm._px2rem(_vm.imgStyle, 75)),
    attrs: {
      "resize": "cover",
      "src": _vm.image,
      "data-img-src": _vm.image,
      "weex-type": "image"
    }
  }) : _vm._e()], {}), _vm._v(" "), _vm._t("content", [(_vm.content) ? _c('p', {
    staticClass: "content-subtext weex-el weex-text",
    style: ({
      fontFamily: _vm._isColmo ? 'PingFangSC-Regular' : _vm.title ? 'PingFangSC-Regular' : 'PingFangSC-Medium',
      color: _vm._subTextColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()], {}), _vm._v(" "), _vm._t("input", [(_vm.hasInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputContent),
      expression: "inputContent"
    }],
    staticClass: "search-bar-input",
    attrs: {
      "placeholder": _vm.placeholder,
      "upriseOffset": _vm.inputUpriseOffset
    },
    domProps: {
      "value": (_vm.inputContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputContent = $event.target.value
      }
    }
  }) : _vm._e()], {})], 2), _vm._v(" "), (_vm.btnGroup && _vm.btnGroup.length == 0) ? _c('div', {
    staticClass: "modal-footer weex-ct weex-div",
    style: ({
      borderTopColor: _vm._modalFooterBorderColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [(!_vm.single) ? _c('div', {
    staticClass: "footer-btn cancel weex-ct weex-div",
    style: ({
      borderRightColor: _vm._modalFooterBorderColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "btn-text weex-el weex-text",
    style: ({
      color: _vm._secondBtnColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('div', {
    staticClass: "mask weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cancelClicked($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer-btn confirm weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "btn-text weex-el weex-text",
    style: ({
      color: _vm.mainBtnColor ? _vm.mainBtnColor : _vm._isColmo ? '#B35336' : _vm._isDiablo ? '#0490d3' : '#00A4F2',
      fontFamily: _vm._isColmo ? 'PingFangSC-Regular' : 'PingFangSC-Medium'
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.confirmText))]), _vm._v(" "), _c('div', {
    staticClass: "mask weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.primaryClicked($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.btnGroup && _vm.btnGroup.length > 0) ? _c('div', {
    staticClass: "more-btn weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.btnGroup), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "footer-more-btn weex-ct weex-div",
      style: ({
        borderTopColor: _vm._modalFooterBorderColor
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: "btn-text weex-el weex-text",
      style: ({
        color: item.color ? item.color : _vm._secondBtnColor
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.text || item))]), _vm._v(" "), _c('div', {
      staticClass: "mask weex-ct weex-div",
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.moreBtnClicked(index, item)
        }
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.closeIcon || _vm.isShowCloseIcon) ? _c('div', {
    staticClass: "closeIconBox weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.closeIconClick($event)
      }
    }
  }, [(_vm.closeIcon) ? _c('figure', {
    staticClass: "closeIcon weex-el weex-image",
    attrs: {
      "src": _vm.closeIcon,
      "data-img-src": _vm.closeIcon,
      "weex-type": "image"
    }
  }) : _c('dof-iconfont', {
    staticClass: "closeIconFont",
    attrs: {
      "code": '\u4725',
      "size": 48,
      "color": _vm._isColmo ? 'rgba(255,255,255,0.80)' : '#333',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.closeIconClick
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59d06228", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d06228","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-modal/index.vue
// module id = 627
// module chunks = 0 1